import React from "react";
export default function Spinner(){
    return(
        <div className="h-full aspect-square  flex items-center justify-center ">
            <img className="" src="./spinner.svg" alt=""></img>
        </div>
    );
}